import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { tr } from 'date-fns/locale';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-template-preview',
  templateUrl: './template-preview.component.html',
  styleUrls: ['./template-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplatePreviewComponent implements OnInit, OnChanges, OnDestroy {


  url = '';
  sanitizedUrl = '';

  templateData: any;
  mediaType: string | null = null;
  headerImageUrl: string | null = null;
  @Input() isNotDialog = false;
  @Input() templatePreviewData: any;
  @Input() uploadedMediaUrl: string | null = null; // new media uploaded in send-template
  templateCurrentStatus: any;

  constructor(
    @Optional() public dialogRef: MatDialogRef<TemplatePreviewComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer, private router: Router,
    private cdr: ChangeDetectorRef
  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
    //this.initializeTemplateData();
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }
  ngOnInit(): void {
    console.log("template preview component camed")
    this.initializeTemplateData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // When uploadedMediaUrl changes (new image uploaded in send-template), trigger change detection
    if (changes['uploadedMediaUrl']) {
      this.cdr.markForCheck();
    }
  }
  private initializeTemplateData() {
    if (this.isNotDialog == true) {
      console.log("the template data before", this.templatePreviewData);
      let parseddata;
      try {
        parseddata = JSON.parse(this.templatePreviewData?.data || '{}');
      } catch (e) {
        console.error("Failed to parse templatePreviewData.data:", e);
        return;
      }

      this.templateData = parseddata?.template?.template || parseddata?.template || parseddata;
      console.log("the template data after", this.templateData);
    }
    else {

      this.templateData = this.data?.template?.template || this.data?.template || this.data;
      this.templateCurrentStatus = this.data?.template?.templateStatus;
    }

    console.log('Processed template data:', this.templateData);

    const header = this.getHeaderComponent();
    if (header?.format === 'IMAGE' && header?.example?.header_handle?.[0]) {
      this.headerImageUrl = header.example.header_handle[0];
    }
  }

  getHeaderComponent() {
    if (!this.templateData?.components) return null;
    return this.templateData.components.find((c: any) => c.type === 'HEADER');
  }

  getBodyComponent() {
    if (!this.templateData?.components) return null;
    return this.templateData.components.find((c: any) => c.type === 'BODY');
  }

  getFooterComponent() {
    if (!this.templateData?.components) return null;
    return this.templateData.components.find((c: any) => c.type === 'FOOTER');
  }

  getButtonsComponent() {
    if (!this.templateData?.components) return null;
    return this.templateData.components.find((c: any) => c.type === 'BUTTONS');
  }

  formatWhatsAppText(text: string): SafeHtml {
    if (!text) return '';
    let formatted = text
      .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
      .replace(/_(.*?)_/g, '<em>$1</em>')
      .replace(/~(.*?)~/g, '<del>$1</del>')
      .replace(/```([\s\S]*?)```/g, '<code>$1</code>')
      .replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(formatted);
  }

  getMediaType(header: any): string | null {
    if (!header || !header.format) return null;

    switch (header.format) {
      case 'IMAGE':
        return 'image';
      case 'VIDEO':
        return 'video';
      case 'DOCUMENT':
        return 'document';
      case 'LOCATION':
        return 'location';
      default:
        return null;
    }
  }

  getMediaPlaceholderIcon(header: any): string {
    switch (header?.format) {
      case 'IMAGE':
        return 'image';
      case 'VIDEO':
        return 'play-circle';
      case 'DOCUMENT':
        return 'file-alt';
      case 'LOCATION':
        return 'map-marker-alt';
      default:
        return 'file-alt';
    }
  }
  close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}